import React, { useState, useEffect } from "react";
import { ThemeCtx, ToastCtx, api, SEV_C, STAT_C, PAGE_SIZE, Pager, Card, Modal, Bdg, Dot, Av, AdminBadge, useToast, ConfirmDialog, usePagination } from "../shared.js";

export function PageTokenUsage({user}){
  var T=React.useContext(ThemeCtx).T;
  var _data=useState(null);  var data=_data[0];  var setData=_data[1];
  var _load=useState(true);  var load=_load[0];  var setLoad=_load[1];
  var _err=useState("");     var err=_err[0];    var setErr=_err[1];
  var PURPLE="#A100FF";

  useEffect(function(){
    api.get("/agent/usage")
      .then(function(d){setData(d);setLoad(false);})
      .catch(function(e){setErr(e.message);setLoad(false);});
  },[]);

  var _pricing=useState([]);  var pricing=_pricing[0];  var setPricing=_pricing[1];
  var _pEdit=useState(null);  var pEdit=_pEdit[0];      var setPEdit=_pEdit[1];
  var _pNew=useState(false);  var pNew=_pNew[0];        var setPNew=_pNew[1];
  var _pForm=useState({model:"",display_name:"",input_cost:"",output_cost:"",notes:""});
  var pForm=_pForm[0]; var setPForm=_pForm[1];
  var _pMsg=useState("");     var pMsg=_pMsg[0];        var setPMsg=_pMsg[1];

  useEffect(function(){
    api.get("/agent/pricing").then(setPricing).catch(function(){});
  },[]);

  var savePricing = async function(){
    try{
      await api.post("/agent/pricing",{
        model:pForm.model, display_name:pForm.display_name,
        input_cost:Number(pForm.input_cost), output_cost:Number(pForm.output_cost),
        notes:pForm.notes
      });
      var updated=await api.get("/agent/pricing");
      setPricing(updated); setPNew(false); setPEdit(null);
      setPForm({model:"",display_name:"",input_cost:"",output_cost:"",notes:""});
      setPMsg("Saved"); setTimeout(function(){setPMsg("");},2000);
    } catch(e){ setPMsg("Error: "+e.message); }
  };

  var deletePricing = async function(model){
    if(!window.confirm("Delete pricing for "+model+"?")) return;
    try{
      await api.delete("/agent/pricing/"+encodeURIComponent(model));
      setPricing(function(p){return p.filter(function(r){return r.model!==model;});});
    } catch(e){ setPMsg("Error: "+e.message); }
  };

  if(load) return React.createElement("div",{style:{color:T.text3,padding:20}},"Loading usage data...");
  if(err)  return React.createElement("div",{style:{color:T.danger,padding:20}},"Error: ",err);
  if(!data) return null;

  var t=data.totals||{};
  var kpis=[
    {label:"Total Calls",    val:Number(t.total_calls||0).toLocaleString(),  c:PURPLE},
    {label:"Input Tokens",   val:Number(t.total_input||0).toLocaleString(),  c:T.info},
    {label:"Output Tokens",  val:Number(t.total_output||0).toLocaleString(), c:T.accent},
    {label:"Total Tokens",   val:Number(t.total_tokens||0).toLocaleString(), c:T.text},
    {label:"Est. Cost (USD)",val:"$"+Number(t.total_cost||0).toFixed(4),     c:T.success},
    {label:"Errors",         val:Number(t.errors||0).toLocaleString(),        c:Number(t.errors)>0?T.danger:T.text3},
    {label:"Avg Latency",    val:(t.avg_ms||0)+"ms",                         c:T.warning},
  ];

  return React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:14}},

    React.createElement("div",{style:{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(120px,1fr))",gap:10}},
      kpis.map(function(k){
        return React.createElement(Card,{key:k.label,style:{textAlign:"center",padding:"12px 8px"}},
          React.createElement("div",{style:{fontSize:20,fontWeight:700,color:k.c}},k.val),
          React.createElement("div",{style:{fontSize:11,color:T.text3,marginTop:2}},k.label)
        );
      })
    ),

    React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}},
      React.createElement(Card,null,
        React.createElement("div",{style:{fontSize:13,fontWeight:700,color:T.text,marginBottom:10}},"By Action"),
        React.createElement("table",{style:{width:"100%",borderCollapse:"collapse",fontSize:12}},
          React.createElement("thead",null,React.createElement("tr",null,
            ["Action","Calls","Tokens","Cost"].map(function(h){
              return React.createElement("th",{key:h,style:{textAlign:"left",padding:"4px 8px",color:T.text3,fontWeight:600,borderBottom:"1px solid "+T.border}},h);
            })
          )),
          React.createElement("tbody",null,
            (data.byAction||[]).map(function(r){
              return React.createElement("tr",{key:r.action,style:{borderBottom:"1px solid "+T.border+"44"}},
                React.createElement("td",{style:{padding:"5px 8px",color:PURPLE,fontWeight:600}},r.action),
                React.createElement("td",{style:{padding:"5px 8px",color:T.text}},r.calls),
                React.createElement("td",{style:{padding:"5px 8px",color:T.text}},Number(r.tokens||0).toLocaleString()),
                React.createElement("td",{style:{padding:"5px 8px",color:T.success}},"$"+Number(r.cost||0).toFixed(4))
              );
            })
          )
        )
      ),
      React.createElement(Card,null,
        React.createElement("div",{style:{fontSize:13,fontWeight:700,color:T.text,marginBottom:10}},"By User"),
        React.createElement("table",{style:{width:"100%",borderCollapse:"collapse",fontSize:12}},
          React.createElement("thead",null,React.createElement("tr",null,
            ["User","Calls","Tokens","Cost"].map(function(h){
              return React.createElement("th",{key:h,style:{textAlign:"left",padding:"4px 8px",color:T.text3,fontWeight:600,borderBottom:"1px solid "+T.border}},h);
            })
          )),
          React.createElement("tbody",null,
            (data.byUser||[]).map(function(r){
              return React.createElement("tr",{key:r.user_name,style:{borderBottom:"1px solid "+T.border+"44"}},
                React.createElement("td",{style:{padding:"5px 8px",color:T.text,fontWeight:600}},r.user_name||"Unknown"),
                React.createElement("td",{style:{padding:"5px 8px",color:T.text}},r.calls),
                React.createElement("td",{style:{padding:"5px 8px",color:T.text}},Number(r.tokens||0).toLocaleString()),
                React.createElement("td",{style:{padding:"5px 8px",color:T.success}},"$"+Number(r.cost||0).toFixed(4))
              );
            })
          )
        )
      )
    ),

    React.createElement(Card,null,
      React.createElement("div",{style:{fontSize:13,fontWeight:700,color:T.text,marginBottom:10}},"Daily Token Usage — Last 30 Days"),
      data.byDay&&data.byDay.length>0
        ? React.createElement("div",{style:{display:"flex",alignItems:"flex-end",gap:3,height:80,overflowX:"auto",paddingBottom:4}},
            (function(){
              var max=Math.max.apply(null,data.byDay.map(function(d){return Number(d.tokens)||0;}))||1;
              return data.byDay.map(function(d){
                var h=Math.max(4,Math.round((Number(d.tokens)/max)*76));
                return React.createElement("div",{key:d.day,title:d.day+" | Tokens: "+Number(d.tokens).toLocaleString()+" | Calls: "+d.calls+" | Cost: $"+Number(d.cost).toFixed(4),style:{display:"flex",flexDirection:"column",alignItems:"center",flex:"1 0 12px",minWidth:12}},
                  React.createElement("div",{style:{width:"100%",height:h,background:PURPLE+"99",borderRadius:"2px 2px 0 0"}}),
                  React.createElement("div",{style:{fontSize:9,color:T.text3,marginTop:2,transform:"rotate(-45deg)",transformOrigin:"top left",whiteSpace:"nowrap"}},d.day.slice(5))
                );
              });
            })()
          )
        : React.createElement("div",{style:{color:T.text3,fontSize:12}},"No usage data yet — make some AI calls first.")
    ),

    React.createElement(Card,null,
      React.createElement("div",{style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}},
        React.createElement("div",{style:{fontSize:13,fontWeight:700,color:T.text}},"Model Pricing Config"),
        React.createElement("div",{style:{display:"flex",gap:8,alignItems:"center"}},
          pMsg&&React.createElement("span",{style:{fontSize:12,color:T.success}},pMsg),
          React.createElement("button",{onClick:function(){setPNew(true);setPEdit(null);setPForm({model:"",display_name:"",input_cost:"",output_cost:"",notes:""});},style:{background:PURPLE,color:"#fff",border:"none",borderRadius:6,padding:"4px 12px",fontSize:12,cursor:"pointer",fontWeight:600}},"+ Add Model")
        )
      ),
      React.createElement("div",{style:{fontSize:11,color:T.text3,marginBottom:10}},"Cost per 1M tokens — used for all future AI call cost calculations"),
      React.createElement("div",{style:{overflowX:"auto"}},
        React.createElement("table",{style:{width:"100%",borderCollapse:"collapse",fontSize:12}},
          React.createElement("thead",null,React.createElement("tr",null,
            ["Model","Display Name","Input $/1M","Output $/1M","Notes","Updated",""].map(function(h){
              return React.createElement("th",{key:h,style:{textAlign:"left",padding:"4px 8px",color:T.text3,fontWeight:600,borderBottom:"1px solid "+T.border,whiteSpace:"nowrap"}},h);
            })
          )),
          React.createElement("tbody",null,
            pricing.map(function(r){
              var isEditing=pEdit===r.model;
              return React.createElement("tr",{key:r.model,style:{borderBottom:"1px solid "+T.border+"44"}},
                React.createElement("td",{style:{padding:"5px 8px",color:PURPLE,fontWeight:600,fontFamily:"monospace",fontSize:11}},r.model),
                React.createElement("td",{style:{padding:"5px 8px",color:T.text}},
                  isEditing
                    ? React.createElement("input",{value:pForm.display_name,onChange:function(e){setPForm(function(f){return Object.assign({},f,{display_name:e.target.value});});},style:{background:T.inset,border:"1px solid "+T.border,borderRadius:4,padding:"2px 6px",color:T.text,fontSize:12,width:"100%"}})
                    : r.display_name),
                React.createElement("td",{style:{padding:"5px 8px"}},
                  isEditing
                    ? React.createElement("input",{type:"number",step:"0.01",value:pForm.input_cost,onChange:function(e){setPForm(function(f){return Object.assign({},f,{input_cost:e.target.value});});},style:{background:T.inset,border:"1px solid "+T.border,borderRadius:4,padding:"2px 6px",color:T.text,fontSize:12,width:80}})
                    : React.createElement("span",{style:{color:T.success,fontWeight:600}},"$"+Number(r.input_cost).toFixed(3))),
                React.createElement("td",{style:{padding:"5px 8px"}},
                  isEditing
                    ? React.createElement("input",{type:"number",step:"0.01",value:pForm.output_cost,onChange:function(e){setPForm(function(f){return Object.assign({},f,{output_cost:e.target.value});});},style:{background:T.inset,border:"1px solid "+T.border,borderRadius:4,padding:"2px 6px",color:T.text,fontSize:12,width:80}})
                    : React.createElement("span",{style:{color:T.warning,fontWeight:600}},"$"+Number(r.output_cost).toFixed(3))),
                React.createElement("td",{style:{padding:"5px 8px",color:T.text3,fontSize:11}},
                  isEditing
                    ? React.createElement("input",{value:pForm.notes,onChange:function(e){setPForm(function(f){return Object.assign({},f,{notes:e.target.value});});},style:{background:T.inset,border:"1px solid "+T.border,borderRadius:4,padding:"2px 6px",color:T.text,fontSize:12,width:"100%"}})
                    : (r.notes||"—")),
                React.createElement("td",{style:{padding:"5px 8px",color:T.text3,fontSize:11,whiteSpace:"nowrap"}},
                  r.updated_by?r.updated_by+" · ":"",new Date(r.updated_at).toLocaleDateString()),
                React.createElement("td",{style:{padding:"5px 8px",whiteSpace:"nowrap"}},
                  isEditing
                    ? React.createElement("span",null,
                        React.createElement("button",{onClick:savePricing,style:{background:T.success,color:"#fff",border:"none",borderRadius:4,padding:"2px 8px",fontSize:11,cursor:"pointer",marginRight:4}},"Save"),
                        React.createElement("button",{onClick:function(){setPEdit(null);},style:{background:T.inset,color:T.text2,border:"1px solid "+T.border,borderRadius:4,padding:"2px 8px",fontSize:11,cursor:"pointer"}},"Cancel"))
                    : React.createElement("span",null,
                        React.createElement("button",{onClick:function(){setPEdit(r.model);setPForm({model:r.model,display_name:r.display_name,input_cost:String(r.input_cost),output_cost:String(r.output_cost),notes:r.notes||""});},style:{background:T.inset,color:T.text2,border:"1px solid "+T.border,borderRadius:4,padding:"2px 8px",fontSize:11,cursor:"pointer",marginRight:4}},"Edit"),
                        React.createElement("button",{onClick:function(){deletePricing(r.model);},style:{background:T.danger+"22",color:T.danger,border:"1px solid "+T.danger+"44",borderRadius:4,padding:"2px 8px",fontSize:11,cursor:"pointer"}},"Del"))
                )
              );
            }),
            pNew&&React.createElement("tr",{style:{background:T.accentBg}},
              React.createElement("td",{style:{padding:"5px 8px"}},React.createElement("input",{placeholder:"model-id",value:pForm.model,onChange:function(e){setPForm(function(f){return Object.assign({},f,{model:e.target.value});});},style:{background:T.inset,border:"1px solid "+T.border,borderRadius:4,padding:"2px 6px",color:T.text,fontSize:12,width:"100%"}})),
              React.createElement("td",{style:{padding:"5px 8px"}},React.createElement("input",{placeholder:"Display name",value:pForm.display_name,onChange:function(e){setPForm(function(f){return Object.assign({},f,{display_name:e.target.value});});},style:{background:T.inset,border:"1px solid "+T.border,borderRadius:4,padding:"2px 6px",color:T.text,fontSize:12,width:"100%"}})),
              React.createElement("td",{style:{padding:"5px 8px"}},React.createElement("input",{type:"number",step:"0.01",placeholder:"0.00",value:pForm.input_cost,onChange:function(e){setPForm(function(f){return Object.assign({},f,{input_cost:e.target.value});});},style:{background:T.inset,border:"1px solid "+T.border,borderRadius:4,padding:"2px 6px",color:T.text,fontSize:12,width:80}})),
              React.createElement("td",{style:{padding:"5px 8px"}},React.createElement("input",{type:"number",step:"0.01",placeholder:"0.00",value:pForm.output_cost,onChange:function(e){setPForm(function(f){return Object.assign({},f,{output_cost:e.target.value});});},style:{background:T.inset,border:"1px solid "+T.border,borderRadius:4,padding:"2px 6px",color:T.text,fontSize:12,width:80}})),
              React.createElement("td",{style:{padding:"5px 8px"}},React.createElement("input",{placeholder:"Notes",value:pForm.notes,onChange:function(e){setPForm(function(f){return Object.assign({},f,{notes:e.target.value});});},style:{background:T.inset,border:"1px solid "+T.border,borderRadius:4,padding:"2px 6px",color:T.text,fontSize:12,width:"100%"}})),
              React.createElement("td",null),
              React.createElement("td",{style:{padding:"5px 8px",whiteSpace:"nowrap"}},
                React.createElement("button",{onClick:savePricing,style:{background:T.success,color:"#fff",border:"none",borderRadius:4,padding:"2px 8px",fontSize:11,cursor:"pointer",marginRight:4}},"Save"),
                React.createElement("button",{onClick:function(){setPNew(false);},style:{background:T.inset,color:T.text2,border:"1px solid "+T.border,borderRadius:4,padding:"2px 8px",fontSize:11,cursor:"pointer"}},"Cancel")
              )
            )
          )
        )
      )
    ),

    React.createElement(Card,null,
      React.createElement("div",{style:{fontSize:13,fontWeight:700,color:T.text,marginBottom:10}},"Recent Calls (last 20)"),
      React.createElement("div",{style:{overflowX:"auto"}},
        React.createElement("table",{style:{width:"100%",borderCollapse:"collapse",fontSize:11}},
          React.createElement("thead",null,React.createElement("tr",null,
            ["Time","User","Action","Model","In","Out","Cost","Latency","Status"].map(function(h){
              return React.createElement("th",{key:h,style:{textAlign:"left",padding:"4px 8px",color:T.text3,fontWeight:600,borderBottom:"1px solid "+T.border,whiteSpace:"nowrap"}},h);
            })
          )),
          React.createElement("tbody",null,
            (data.recent||[]).map(function(r){
              var ts=new Date(r.created_at);
              var timeStr=ts.toLocaleDateString()+" "+ts.toLocaleTimeString().slice(0,5);
              return React.createElement("tr",{key:r.id,style:{borderBottom:"1px solid "+T.border+"33"}},
                React.createElement("td",{style:{padding:"4px 8px",color:T.text3,whiteSpace:"nowrap"}},timeStr),
                React.createElement("td",{style:{padding:"4px 8px",color:T.text}},r.user_name||"—"),
                React.createElement("td",{style:{padding:"4px 8px",color:PURPLE,fontWeight:600}},r.action),
                React.createElement("td",{style:{padding:"4px 8px",color:T.text3}},r.model),
                React.createElement("td",{style:{padding:"4px 8px",color:T.text}},Number(r.input_tokens).toLocaleString()),
                React.createElement("td",{style:{padding:"4px 8px",color:T.text}},Number(r.output_tokens).toLocaleString()),
                React.createElement("td",{style:{padding:"4px 8px",color:T.success}},"$"+Number(r.cost_usd).toFixed(5)),
                React.createElement("td",{style:{padding:"4px 8px",color:T.text3}},r.duration_ms+"ms"),
                React.createElement("td",{style:{padding:"4px 8px"}},
                  r.success
                    ? React.createElement("span",{style:{color:T.success,fontWeight:600}},"OK")
                    : React.createElement("span",{style:{color:T.danger,fontWeight:600},title:r.error||""},"ERR")
                )
              );
            })
          )
        )
      )
    )
  );
}
